"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANDING_STATUS = void 0;
exports.LANDING_STATUS = {
    ACTIVE: 'ACTIVE',
    ARCHIVED: 'ARCHIVED',
    DEPRECATED: 'DEPRECATED'
};
//# sourceMappingURL=landingStatus.js.map